import type { Answer, CommunityEvent, ContactFact, HelpTopic, NavGroup, NavLink } from "../types/content";

export const SITE_ORIGIN = "https://www.motorcyclelawyermichigan.com";

export const firm = {
  legalName: "Law Offices of Jason A. Waechter",
  attorney: "Jason Waechter",
  mark: "The Motorcycle Lawyer®",
  phoneDisplay: "1-877-BIKERLAW",
  phoneDigits: "1-877-245-3752",
  phoneHref: "tel:18772453752",
};

export const logos = {
  desktop: {
    src: "https://www.motorcyclelawyermichigan.com/wp-content/uploads/2025/03/logo_desktop.svg",
    width: 353,
    height: 97,
  },
  compact: {
    src: "https://www.motorcyclelawyermichigan.com/wp-content/uploads/2025/03/mobile_logo.svg",
    width: 62,
    height: 63,
  },
};

export const navGroups: NavGroup[] = [
  {
    id: "accident-help",
    label: "Accident Help",
    links: [
      { label: "No-fault claims", path: "/practice-area/michigan-motorcyclists-no-fault-claims/" },
      { label: "Car vs. motorcycle", path: "/practice-area/car-vs-motorcycle-accidents/" },
      { label: "Hit-and-run crashes", path: "/practice-area/motorcycle-hit-and-run-accident/" },
      { label: "Wrongful death", path: "/practice-area/wrongful-death-motorcycle-accident/" },
    ],
  },
  {
    id: "about",
    label: "About",
    links: [
      { label: "About the firm", path: "/about-us/" },
      { label: "Jason A. Waechter", path: "/team/jason-a-waechter/" },
      { label: "Client testimonials", path: "/law-firm-testimonials/" },
    ],
  },
  {
    id: "resources",
    label: "Resources",
    links: [
      { label: "Common questions", path: "/#answers" },
      { label: "A motorcycle injury verdict story", path: "/27-million-motorcycle-injury-verdict/" },
    ],
  },
  {
    id: "events",
    label: "Events",
    links: [
      { label: "All events", path: "/events/" },
      {
        label: "Flint Indoor Motorcycle Ice Race",
        path: "/event/flint-motorcycle-club-indoor-motorcycle-ice-race-2026/",
      },
    ],
  },
];

export const trustLinks: NavLink[] = [
  { label: "About the firm", path: "/about-us/" },
  { label: "Client testimonials", path: "/law-firm-testimonials/" },
  { label: "A motorcycle injury verdict story", path: "/27-million-motorcycle-injury-verdict/" },
];

export const helpTopics: HelpTopic[] = [
  {
    title: "No-fault claims",
    summary: "Medical bills and benefits after a Michigan motorcycle crash.",
    path: "/practice-area/michigan-motorcyclists-no-fault-claims/",
  },
  {
    title: "Car vs. motorcycle",
    summary: "Driver negligence claims when a car and a motorcycle collide.",
    path: "/practice-area/car-vs-motorcycle-accidents/",
  },
  {
    title: "Hit-and-run crashes",
    summary: "When the driver is unknown or uninsured.",
    path: "/practice-area/motorcycle-hit-and-run-accident/",
  },
  {
    title: "Wrongful death",
    summary: "For families after a crash that took a rider's life.",
    path: "/practice-area/wrongful-death-motorcycle-accident/",
  },
];

export const contactFacts: ContactFact[] = [
  {
    term: "How to reach the firm",
    detail: "Call 1-877-BIKERLAW, or send the free case review form on this page.",
  },
  {
    term: "What the form asks for",
    detail: "Your first and last name, phone number and email. A ZIP code and crash details are optional.",
  },
  {
    term: "Cases the firm reviews",
    detail: "Michigan motorcycle injury and death cases.",
  },
  {
    term: "Cost of the review",
    detail: "The case review is free.",
  },
];

export const answers: Answer[] = [
  {
    id: "request-review",
    question: "How do I request a free case review?",
    answer: "Call 1-877-BIKERLAW or use the case review form on this page to contact the Law Offices of Jason A. Waechter.",
    link: { label: "Go to the case review form", path: "/#case-review" },
  },
  {
    id: "review-information",
    question: "What information does the case review form ask for?",
    answer: "The form asks for your first and last name, phone number and email address. You can also add a ZIP code and a short description of the crash.",
    link: { label: "Request a free case review", path: "/#case-review" },
  },
  {
    id: "about-jason",
    question: "Where can I learn more about Jason Waechter?",
    answer: "Read Jason Waechter's attorney profile to learn more about The Motorcycle Lawyer and the Law Offices of Jason A. Waechter.",
    link: { label: "Read Jason's profile", path: "/team/jason-a-waechter/" },
  },
];

export const upcomingEvents: CommunityEvent[] = [
  {
    id: "flint-ice-race-2026",
    title: "Flint Motorcycle Club Indoor Motorcycle Ice Race",
    weekday: "Sat",
    dateLabel: "Saturday, December 5, 2026",
    monthShort: "Dec",
    day: "5",
    year: "2026",
    isoStart: "2026-12-05T19:00:00-05:00",
    timeLabel: "Racing at 7 pm Eastern",
    venue: "Dort Financial Center",
    location: "Flint, Michigan",
    path: "/event/flint-motorcycle-club-indoor-motorcycle-ice-race-2026/",
  },
];

export const footerGroups: NavGroup[] = [
  {
    id: "footer-firm",
    label: "The firm",
    links: [
      { label: "About the firm", path: "/about-us/" },
      { label: "Jason A. Waechter", path: "/team/jason-a-waechter/" },
      { label: "Client testimonials", path: "/law-firm-testimonials/" },
    ],
  },
  {
    id: "footer-help",
    label: "Get help",
    links: [
      { label: "Free case review", path: "/#case-review" },
      { label: "Common questions", path: "/#answers" },
      { label: "Events", path: "/events/" },
    ],
  },
];

export const resultsDisclaimer = "Past results do not guarantee future outcomes. Every case depends on its own facts.";
